import { render, staticRenderFns } from "./ListDHRDetailProduction.vue?vue&type=template&id=8d5cd028&scoped=true&"
import script from "./ListDHRDetailProduction.vue?vue&type=script&lang=js&"
export * from "./ListDHRDetailProduction.vue?vue&type=script&lang=js&"
import style0 from "./ListDHRDetailProduction.vue?vue&type=style&index=0&id=8d5cd028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5cd028",
  null
  
)

export default component.exports